import type { IPilotDiagnosticReportCustomControlData } from './types';
import { translateKey } from '../../../../../../translate';
import { ReadCustomControlData } from '../../../../../elements/forms/ReadCustomControlData';

export function PilotExaminationV1DiagnosticReportReadCustomControlFields(props: {
    customControlData: IPilotDiagnosticReportCustomControlData;
}) {
    return (
        <>
            <ReadCustomControlData
                label={'Afwijkend'}
                value={props.customControlData.afwijkend}
            />
            <ReadCustomControlData
                label={translateKey('diagnosticReport.remarks')}
                value={props.customControlData.toelichting_bevindingen}
            />
        </>
    );
}
